(function () {
    'use strict';

    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('rapor-dogrulama', {
                url: "/:langcode/rapor-dogrulama?kod",
                templateUrl: 'app/report/rapor-dogrulama.html',
                controller: 'RaporDogrulamaController',
                params: {
                    langcode: {
                        value: ['$translate', function ($translate) {
                            return $translate.use();
                        }]
                    }
                },
                resolve: {
                    lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                        return lazyLoadSvc.load($transition$, 'report');
                    }],

                    trans: '$transition$',

                    langcode: ['$stateParams', function ($stateParams) {
                        document.cookie = 'langcode=' + $stateParams.langcode;
                    }],

                    translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                        $translatePartialLoader.addPart("report_order");
                        return $translate.refresh();
                    }]
                },
                metaTags: {
                    robots: 'noindex, nofollow',
                    title: ['$translate', function ($translate) {
                        return $translate('c_an_rep').then(function (res) {
                            return res;
                        });
                    }]
                }
            });
    }]);
})();
